import SelectColumn from './column.vue'
import SelectArea from './area.vue'
import SelectLang from './lang.vue'

export {
  SelectColumn,
  SelectArea,
  SelectLang
}
